import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { useHeaderExtras } from "@/context/HeaderExtras";

const TITLES = {
  "/transactions": { en: "Transactions", ar: "المعاملات" },
  "/budgets": { en: "Budgets", ar: "الميزانيات" },
  "/account": { en: "Account", ar: "حسابي" },
  "/admin": { en: "Admin", ar: "لوحة التحكم" },
  "/accounts": { en: "My Accounts", ar: "حساباتي" },
  "/cheques": { en: "Cheques", ar: "الشيكات" },
};

const GLASS = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 40,
  paddingTop: "calc(env(safe-area-inset-top) + 10px)",
  paddingBottom: "10px",
  background: "rgba(236, 238, 241, 0.68)",
  WebkitBackdropFilter: "blur(20px) saturate(180%)",
  backdropFilter: "blur(20px) saturate(180%)",
  borderBottom: "1px solid rgba(255, 255, 255, 0.12)",
  boxShadow: "0 1px 12px rgba(0, 0, 0, 0.08)",
};

export function Header() {
  const { user } = useAuth();
  const { lang } = useI18n();
  const loc = useLocation();
  const { extras } = useHeaderExtras();
  if (!user) return null;
  const title = TITLES[loc.pathname];
  if (loc.pathname === "/") return null;
  if (["/login", "/signup"].includes(loc.pathname)) return null;
  if (!title) return null;
  return (
    <header data-testid="app-header" style={GLASS}>
      <div className="max-w-6xl mx-auto flex items-center justify-between gap-3 px-4 py-1.5 min-h-[44px]">
        <h1 className="font-display text-xl sm:text-2xl font-bold neu-accent-blue tracking-tight">
          {lang === "ar" ? title.ar : title.en}
        </h1>
        {extras && <div className="flex items-center gap-2 shrink-0">{extras}</div>}
      </div>
    </header>
  );
}
